import { Code2, Copy } from "lucide-react";
import { copy } from "@/lib/clipboard";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Snippet = ({ label, code, testid }) => (
  <div className="flex flex-col gap-2 min-w-0">
    <div className="flex items-center justify-between">
      <span className="text-[9px] font-mono uppercase tracking-widest text-atlas-secondary/85">{label}</span>
      <button onClick={() => copy(code, `${label} copied`)} data-testid={`${testid}-copy`}
        className="flex items-center gap-1.5 px-2.5 h-7 border border-atlas-cyan/40 text-[10px] font-mono uppercase tracking-wider text-atlas-cyan hover:bg-atlas-cyan hover:text-atlas-void transition-colors">
        <Copy className="w-3 h-3" /> Copy
      </button>
    </div>
    <pre className="bg-atlas-void border border-white/10 p-3 text-[11px] font-mono text-atlas-secondary whitespace-pre-wrap break-all" data-testid={`${testid}-code`}>{code}</pre>
  </div>
);

export const EmbedPanel = () => {
  const origin = window.location.origin;
  const iframe = `<iframe src="${origin}/embed" width="440" height="190" style="border:0" title="Vigilo Earth latest confirmed lead time" loading="lazy"></iframe>`;
  const badge = `<a href="${origin}/confirmed"><img src="${BACKEND}/api/widget/badge.svg" alt="Vigilo Earth latest confirmed lead time" width="440" height="72"></a>`;
  return (
    <section className="mt-12 border border-white/10 bg-atlas-surface/70 p-5" data-testid="embed-panel">
      <div className="flex items-center gap-2 mb-1">
        <Code2 className="w-4 h-4 text-atlas-cyan" />
        <h2 className="text-base md:text-lg font-display text-white">Embed the proof</h2>
      </div>
      <p className="text-[12px] text-atlas-secondary mb-5">Partners can drop Vigilo Earth's latest confirmed lead time on their site. Both update live.</p>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="flex flex-col gap-3">
          <span className="text-[9px] font-mono uppercase tracking-widest text-atlas-secondary/85">Live widget preview</span>
          <iframe src="/embed" width="440" height="190" title="Vigilo Earth widget preview" className="border-0 max-w-full" data-testid="embed-preview-iframe" />
          <span className="text-[9px] font-mono uppercase tracking-widest text-atlas-secondary/85 mt-2">SVG badge preview</span>
          <img src={`${BACKEND}/api/widget/badge.svg`} alt="Vigilo Earth badge" width="440" height="72" className="max-w-full" data-testid="embed-badge-preview" />
        </div>
        <div className="flex flex-col gap-5 min-w-0">
          <Snippet label="iframe widget" code={iframe} testid="embed-iframe" />
          <Snippet label="SVG badge" code={badge} testid="embed-badge" />
        </div>
      </div>
    </section>
  );
};
